import { render, staticRenderFns } from "./RelatorioContrato.vue?vue&type=template&id=6d960560&"
import script from "./RelatorioContrato.vue?vue&type=script&lang=js&"
export * from "./RelatorioContrato.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioContrato.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports